import type { PresignedPost } from "@aws-sdk/s3-presigned-post";
import { useCallback } from "react";
import { axiosSettings } from "./axios";

export const usePrepareUploadCerTemplate = () => {
  const [state, execute, cancel] = axiosSettings<PresignedPost, { name: string }, unknown>(
    {
      url: "/v2/organisations/cerTemplate",
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (organisation: string, name: string) => {
      return execute({
        url: `/v2/organisations/${organisation}/cerTemplate`,
        data: { name },
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
